import {Field} from "formik";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import React from "react";

export const FormikTextInputGroup = ({name, label, placeholderLabel, type, disabled}) =>
    <Field name={name}>
        {({field, form}) => {
            return <Form.Group>
                {!placeholderLabel && <Form.Label>
                    {label}
                </Form.Label>}
                {type === 'textarea' ?
                    <Form.Control as="textarea" {...field} rows={3}
                                  disabled={disabled}
                                  isInvalid={_.get(form.touched, field.name) && _.get(form.errors, field.name)}/>
                    :
                    <Form.Control type={type || 'text'} {...field}
                                  placeholder={placeholderLabel ? label : ''}
                                  disabled={disabled}
                                  value={field.value || ''}
                                  isInvalid={_.get(form.touched, field.name) && _.get(form.errors, field.name)}/>
                }
                <Form.Control.Feedback type="invalid">
                    {_.get(form.errors, field.name)}
                </Form.Control.Feedback>
            </Form.Group>
        }}
    </Field>;
